<div data-testid="zone-tile">
    <div class="zone__top border-zone cursor-pointer"
         (click)="zones.goToMenu(tile)">
        <floating-subtitle class="zone__name zone__name--valve font-21"
                           [text]="subtitle(tile.params.txtId)">
        </floating-subtitle>
        <div class="zone__set-temperature bg-gradient bg-gradient--zone font-24 font-bold"
            data-testid="set-temperature-icon">
            <div class="zone__content-icon">
                <icon [iconName]="'schedule'"
                      data-testid="schedule-icon"
                      [iconSize]="40"
                      [className]="'zone__set-temperature-img fill-icon-grey-white'"
                      *ngIf="tile.params.mode === 'schedule'">
                </icon>
                <div class="zone__time-limit-wrapper"
                     *ngIf="tile.params.mode === 'off'">
                    <icon [iconName]="'power'"
                          data-testid="power-icon"
                          [iconSize]="40"
                          [className]="'zone__set-temperature-img fill-icon-grey-white'">
                    </icon>
                    <p class="font-16" data-testid="mode-text">{{ subtitle(1316) }}</p>
                </div>
            </div>
            <div class="zone__time-limit-wrapper">
                <icon [iconName]="'time-limit'"
                      data-testid="time-limit-icon"
                      [iconSize]="40"
                      [className]="'zone__set-temperature-img fill-icon-grey-white'"
                      *ngIf="tile.params.mode === 'timeLimit'">
                </icon>
                <p class="zone__time-limit font-12"
                   data-testid="mode-text"
                   *ngIf="tile.params.mode === 'timeLimit'">
                    {{ (tile.params.durationTime > 0 ? tile.params.durationTime : 1)| format:13 }}
                </p>
            </div>
        </div>
    </div>

    <div class="zone__status cursor-pointer">
        <div class="gradient-zone zone__status-background"
             data-testid="animation"
             [ngClass]="{ 'zone__status--animated': tile.params.isActive }"
             (click)="zones.goToMenu(tile)"
        ></div>
    </div>

    <div class="zone__content cursor-pointer"
         data-testid="tile-icon"
         (click)="zones.goToMenu(tile)">
        <icon [iconName]="'DHW'"
              data-testid="tile-icon-DHW"
              [iconSize]="views.isMobileView() ? 40 : 50"
              [className]="'zone__icon zone__icon--white zone__icon--tile fill-icon-grey'">
        </icon>
        <icon [iconName]="'DHW'"
              data-testid="tile-icon-DHW-mobile"
              [iconSize]="views.isMobileView() ? 40 : 50"
              [className]="'zone__icon zone__icon--dark  fill-black fill-icon-grey'">
        </icon>
        <floating-subtitle
                class="zone__current-temp zone__current-temp--medium zone__current-temp--relay"
                data-testid="tile-value"
                [text]="subtitle(1447)"
                *ngIf="tile.params.isActive && tile.params.mode != 'off'">
        </floating-subtitle>
        <floating-subtitle
                class="zone__current-temp zone__current-temp--medium zone__current-temp--relay"
                data-testid="tile-value"
                [text]="subtitle(924)"
                *ngIf="!tile.params.isActive && tile.params.mode != 'off'">
        </floating-subtitle>
    </div>

    <div class="zone__footer bg-style">
        <div class="zone__icons"></div>
    </div>

    <div class="zone__relay-status-mobile fill-style"
         *ngIf="!(tile.params.mode === 'off')">
        <img class="zone__relay-status-img"
             ngSrc="/assets/img/zone_icons/sun_v1-1.svg"
             data-testid="relay-status-mobile-icon"
             [ngClass]="{ 'zone__relay-status-mobile--animated': tile.params.isActive }"
             width="25" height="25" alt=""/>
    </div>
</div>
